import { useState, useEffect } from 'react';

export const MOBILE_MAX_WIDTH = 767;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

/** Viewport width — for responsive layout only (changes when window is resized). */
export function useIsMobileViewport() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_MEDIA_QUERY).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

/** @deprecated Use useIsMobileViewport for layout or isMobileDevice for login blocking. */
export const useIsMobile = useIsMobileViewport;

/** True only on phones/tablets — does not change when a desktop browser window is resized. */
export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)) {
    return true;
  }

  // iPad on iOS 13+ can report as Mac with touch support
  if (navigator.maxTouchPoints > 1 && /MacIntel|Macintosh/.test(navigator.platform)) {
    return true;
  }

  return false;
}

export function useIsMobileDevice() {
  const [mobile, setMobile] = useState(() => isMobileDevice());

  useEffect(() => {
    setMobile(isMobileDevice());
  }, []);

  return mobile;
}
